module.exports = __webpack_public_path__ + "static/fb73edfe5be7ddc7dd99fbb7fb720b926717851bd0b270726fe0ae33cd2c0f81-5745edbd18739b64ddee4e9a899e098e.png";